<div class="card group relative flex h-full min-h-0 flex-1 flex-col overflow-hidden rounded-none">
    @if (isDocumentLockedSig()) {
        <div class="absolute top-[5%] left-0 right-0 bottom-0 flex justify-center items-center z-10 pointer-events-none">
            <i class="fa-solid fa-lock text-[12rem] text-gray-500/10 transition-colors duration-500 ease-in-out group-hover:text-gray-500/50 pointer-events-auto"
               [pTooltip]="'document-line-item.document-locked-tooltip' | translate"></i>
        </div>
    }
    <app-base-list-wrapper #listWrapper [baseListComponent]="this" [dataTestId]="dataTestId() ">
        <ng-template #moreButtons let-table="table">
            <div
                class="more-buttons-root flex flex-nowrap gap-1 items-center shrink-0"
                [attr.data-testid]="'line-item-toolbar-buttons'"
            >
            <div class="flex gap-1 items-center shrink-0">
                @if (showContractGenerateButton) {
                    <p-popover #contractGenerateSettingsPopover>
                        <div class="m-1 flex min-w-[14rem] flex-col gap-3">
                            <phx-checkbox
                                [ngModel]="saveLineItemsWithStockErrors()"
                                (ngModelChange)="onSaveLineItemsWithStockErrorsChange($event)"
                                [label]="'document.contract-assistant.save-line-items-with-stock-errors' | translate"
                                data-testid="contract-document-save-line-items-with-stock-errors"
                            />
                            <phx-checkbox
                                [ngModel]="generateAllUntilCutOffDate()"
                                (ngModelChange)="ongenerateAllUntilCutOffDateChange($event)"
                                [label]="'document.contract-assistant.generate-all-until-cut-off-date' | translate"
                                data-testid="contract-document-generate-all-until-cut-off-date"
                            />
                            <phx-checkbox
                                [ngModel]="useCutOffDateAsDocumentDate()"
                                (ngModelChange)="onuseCutOffDateAsDocumentDateChange($event)"
                                [label]="'document.contract-assistant.use-cut-off-date-as-document-date' | translate"
                                [tooltip]="'document.contract-assistant.use-cut-off-date-as-document-date-tooltip' | translate"
                                data-testid="contract-document-use-cut-off-date-as-document-date"
                            />
                        </div>
                    </p-popover>
                    <p-button
                        icon="fa fa-cog"
                        [outlined]="true"
                        severity="secondary"
                        (onClick)="contractGenerateSettingsPopover.toggle($event)"
                        data-testid="contract-document-generate-settings"
                    />
                    <p-button
                        [outlined]="true"
                        [disabled]="contractGenerateDisabled || IsLoading"
                        [loading]="contractGenerateLoading"
                        [label]="'document.contract-assistant.generate-selected' | translate"
                        icon="fa-solid fa-file-export"
                        [pTooltip]="contractGenerateTooltip"
                        (onClick)="contractGenerateClick.emit()"
                        [attr.data-testid]="'contract-generate-selected-line-items-btn'"
                    />
                }
                <!-- Show Manual Stock Transaction Button -->
                <p-button
                    [outlined]="true"
                    [disabled]="this.IsLoading"
                    *ngIf="showManualStockTransactionButton()"
                    [icon]="'fa fa-crosshairs'"
                    [pTooltip]="
                        'document-line-item.open-manual-stock-transaction-dialog' | translate
                    "
                    (onClick)="doManualStockTransaction()"
                    [attr.data-testid]="'manual-stock-transaction-btn'"
                />
                @if (
                    this.selectedItems()?.length == 1 && this.lastSelectedItemSig()?.isStorable
                ) {
                <!-- Show Line Item Stock Transaction Button -->
                    <p-button
                        [outlined]="true"
                        [disabled]="
                            !(this.selectedItems()?.length == 1) ||
                            this.IsLoading ||
                            (this.lastSelectedItemSig()?.product?.productType != ProductType.STORE &&
                                this.lastSelectedItemSig()?.product?.productType !=
                                    ProductType.SIMPLEPRODUCTION)
                        "
                        [icon]="'fa fa-boxes'"
                        [pTooltip]="'document-line-item.show-line-item-stock-transactions' | translate"
                        (onClick)="openStockHistoryPopup()"
                        [attr.data-testid]="'line-item-stock-transactions-btn'"
                    />
                    <p-button
                        [outlined]="true"
                        [disabled]="this.IsLoading || !this.lastSelectedItemSig()?.productId"
                        [icon]="'fa-solid fa-warehouse'"
                        [pTooltip]="'product.showWarehouseStockButton' | translate"
                        (onClick)="openSelectedItemWarehouseSidebar()"
                        [attr.data-testid]="'line-item-warehouse-stock-btn'"
                    />
                }
                <!-- Show Line Item Links Button -->
                <!-- TODO: in future we will have another widget to show diagram -->
                <!-- <p-button
                    [outlined]="true"
                    [disabled]="!(this.selectedItems()?.length == 1) || this.loadingSig()"
                    [icon]="'fa fa-project-diagram'"
                    [pTooltip]="'document-line-item.show-line-item-links' | translate"
                    (onClick)="openLineItemLInksPopup()"
                    [attr.data-testid]="'line-item-links-btn'"
                /> -->
                <p-button
                    [outlined]="true"
                    [disabled]="
                        !(this.selectedItems()?.length == 1) ||
                        this.loadingSig() ||
                        !this.lastSelectedItemSig()?.productId
                    "
                    [icon]="'fa-solid fa-chart-line'"
                    [pTooltip]="'document-line-item.show-price-history' | translate"
                    (onClick)="openPriceHistoryDrawer()"
                    [attr.data-testid]="'line-item-price-history-btn'"
                />
                <!-- Show Product in New Tab Button -->
                <p-button
                    [outlined]="true"
                    [disabled]="
                        !(this.selectedItems()?.length == 1) ||
                        this.loadingSig() ||
                        !this.selectedItems()[0].productId
                    "
                    [icon]="'fa fa-external-link-alt'"
                    [pTooltip]="'document-line-item.open-product-in-new-tab' | translate"
                    (onClick)="openSelectedItemInNewTab()"
                    [attr.data-testid]="'open-product-in-new-tab-btn'"
                />

                <!-- MOVE UP / DOWN BUTTONS -->
                <!-- for now we only want to show those if we are not in edit mode -->
                @if (
                    !inEditingSig() &&
                    selectedItems().length > 0 &&
                    this.document()?.status !== DocumentStatusType.CO &&
                    this.document()?.status !== DocumentStatusType.RE
                ) {
                    <p-button
                        [disabled]="!this.canMoveUpSig() || this.IsLoading"
                        [outlined]="true"
                        [icon]="'fa-solid fa-arrow-up'"
                        (onClick)="changeItemPosition(selectedItems(), -upDownDirectionalNumberSig())"
                        [attr.data-testid]="'move-line-item-up-btn'"
                    />
                    <p-button
                        [disabled]="!this.canMoveDownSig() || this.IsLoading"
                        [outlined]="true"
                        [icon]="'fa-solid fa-arrow-down'"
                        (onClick)="changeItemPosition(selectedItems(), upDownDirectionalNumberSig())"
                        [attr.data-testid]="'move-line-item-down-btn'"
                    />
                }

                <!-- INDENT / OUTDENT BUTTONS -->
                <!-- for now not while editing -->
                @if (
                    !inEditingSig() &&
                    selectedItems().length > 0 &&
                    this.document()?.status !== DocumentStatusType.CO &&
                    this.document()?.status !== DocumentStatusType.RE
                ) {
                    <p-button
                        [disabled]="this.IsLoading || !canIndentSignal()"
                        [outlined]="true"
                        [icon]="'fa-solid fa-indent'"
                        (onClick)="indentSelectedItems()"
                        [attr.data-testid]="'indent-line-item-btn'"
                    />

                    <p-button
                        [disabled]="this.IsLoading || !canOutdentSignal()"
                        [outlined]="true"
                        [icon]="'fa-solid fa-outdent'"
                        (onClick)="outdentSelectedItems()"
                        [attr.data-testid]="'outdent-line-item-btn'"
                    />
                }

                @if (canFulfillOpenRequestedQuantitySig()) {
                    <p-button
                        [outlined]="true"
                        [disabled]="this.IsLoading"
                        [icon]="'fa-solid fa-scale-balanced'"
                        [pTooltip]="'document-line-item.fulfill-requested-quantity' | translate"
                        (onClick)="fulfillOpenRequestedQuantityForSelectedItems()"
                        [attr.data-testid]="'fulfill-requested-quantity-btn'"
                    />
                }

                @if (
                    (selectedItems?.length > 0 || this.editModel()?.product) &&
                    this.accessoryConfigExisting &&
                    this.document()?.status !== DocumentStatusType.CO &&
                    this.document()?.status !== DocumentStatusType.RE
                ) {
                    <p-button
                        [outlined]="true"
                        [disabled]="this.IsLoading"
                        [icon]="'fa-solid fa-turn-down'"
                        [pTooltip]="'document-line-item.show-accessory-list' | translate"
                        (onClick)="showAccessoryList()"
                        [attr.data-testid]="'show-accessory-list-btn'"
                    />
                }
                @if (
                    unstockedItemsSig()?.length > 0 &&
                    (this.document()?.documentDefinition?.stockAction === StockAction.IN ||
                        this.document()?.documentDefinition?.stockAction === StockAction.OUT)
                ) {
                    <p-button
                        [outlined]="true"
                        [disabled]="this.IsLoading"
                        [icon]="'fa-solid fa-box'"
                        [pTooltip]="'document-line-item.restock-unstocked-items' | translate"
                        (onClick)="restockUnstockedItems()"
                        [attr.data-testid]="'restock-unstocked-items-btn'"
                    />
                }
            </div>
            </div>
        </ng-template>
        <!-- this would create a empty item!! -->
        <!-- <ng-template #preButtons>
        </ng-template> -->

        <ng-template #preColHeaders>
            <th
                #extendCol
                pResizableColumn
                [width]="40"
                class="!text-center !text-clip"
                [attr.data-testid]="'expand-column-header'"
            >
                <i class="fa-solid fa-magnifying-glass"></i>
            </th>
        </ng-template>
        <ng-template #postColHeaders>
            <th
                #linePriceCol
                [width]="100"
                class="!text-right col-header"
                pFrozenColumn
                alignFrozen="right"
                [frozen]="itemsSig()?.length > 0"
                [attr.data-testid]="'line-price-column-header'"
            >
                <span
                    class="ps-1 pe-1"
                    [pTooltip]="
                        ('entities.DocumentLineItem._' | translate) +
                        ' - ' +
                        ((this.document()?.taxType === TaxType.GROSS
                            ? 'entities.DocumentLineItem.discountedLinePriceWithTax'
                            : 'entities.DocumentLineItem.discountedLinePrice'
                        ) | translate)
                    "
                >
                    @if (this.document()?.taxType === TaxType.GROSS) {
                        {{ 'columns.discountedLinePriceWithTax' | translate }}
                    } @else {
                        {{ 'columns.discountedLinePrice' | translate }}
                    }
                </span>
            </th>
            @if (
                this.document()?.status !== DocumentStatusType.CO &&
                this.document()?.status !== DocumentStatusType.RE
            ) {
                <!-- never less then 70 because otherwise not all fully visible -->
                <th
                    #actionCol
                    [width]="70"
                    class="!text-right"
                    pFrozenColumn
                    alignFrozen="right"
                    [frozen]="itemsSig()?.length > 0"
                    [attr.data-testid]="'actions-column-header'"
                >
                    <span class="ps-1 pe-1">
                        <i class="fa-solid fa-gear" style="color: #4a4e55"></i>
                    </span>
                </th>
            }
        </ng-template>
        <ng-template
            #preCols
            let-rowData="rowData"
            let-rowIndex="rowIndex"
            let-editing="editing"
            let-table="table"
        >
            <!-- Extend -->
            <td (dblclick)="deactivateDoubleClick($event)" [attr.data-testid]="'expand-row-cell'">
                <div class="icon-container">
                    <p-button
                        rounded="true"
                        variant="text"
                        [icon]="'fa-solid fa-angles-right fa-sm'"
                        [ngClass]="{ 'fa-rotate-90': expandedRowKeys.includes(rowData?.id) }"
                        (onClick)="onToggleDetailFields(rowData)"
                        [attr.data-testid]="'expand-row-btn-' + rowIndex"
                    />
                </div>
            </td>
        </ng-template>
        <ng-template
            #postCols
            let-rowData="rowData"
            let-rowIndex="rowIndex"
            let-editing="editing"
            let-table="table"
        >
            <!-- Actions -->
            <td
                #outputCell
                pFrozenColumn
                alignFrozen="right"
                [frozen]="itemsSig()?.length > 0"
                [pEditableRow]="rowData"
                [attr.data-testid]="'line-price-cell-' + rowIndex"
            >
                @if (rowData.type !== DocumentLineItemType.TEXT) {
                    <div class="output-cell-wrapper text-right" [ngClass]="{'text-slate-500': rowData.isOptional}">
                        <p-cellEditor
                            [id]="
                                document()?.taxType === TaxType.GROSS
                                    ? 'discountedLinePriceWithTax'
                                    : 'discountedLinePrice'
                            "
                            [attr.data-testid]="'line-price-editor-' + rowIndex"
                        >
                            @if (document()?.taxType === TaxType.GROSS) {
                                <ng-template pTemplate="input">
                                    <app-dli-line-sum-input
                                        [decimalPlaces]="rowData?.decimalPlaces"
                                        [dli]="rowData"
                                        [ngModel]="rowData?.discountedLinePriceWithTax"
                                        (ngModelChange)="
                                            rowData.discountedLinePriceWithTax = $event
                                        "
                                        [attr.data-testid]="'line-price-with-tax-input-' + rowIndex"
                                    ></app-dli-line-sum-input>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span
                                        [ngClass]="{
                                            'font-bold':
                                                rowData?.type !== DocumentLineItemType.SBOMI,
                                            'italic': rowData?.type === DocumentLineItemType.SBOMI
                                        }"
                                        [attr.data-testid]="
                                            'line-price-with-tax-display-' + rowIndex
                                        "
                                    >
                                        <!-- <i
                                            *ngIf="rowData?.type === DocumentLineItemType.SBOMH"
                                            class="fa-solid fa-sm clickable"
                                            [ngClass]="{
                                                'fa-link': rowData?.isCalculatedItemPrice,
                                                'fa-link-slash': !rowData?.isCalculatedItemPrice
                                            }"
                                            (click)="changeSBOMHStatus(rowData)"
                                        ></i> -->
                                        {{
                                            (rowData?.type === DocumentLineItemType.SBOMI
                                                ? '('
                                                : '') +
                                                (rowData?.discountedLinePriceWithTax | localeCurrency: '' :document()?.decimalPlaces) +
                                                (rowData?.type === DocumentLineItemType.SBOMI
                                                    ? ')'
                                                    : '')
                                        }}
                                    </span>
                                </ng-template>
                            } @else {
                                <ng-template pTemplate="input">
                                    <app-dli-line-sum-input
                                        [decimalPlaces]="rowData?.decimalPlaces"
                                        [dli]="rowData"
                                        [ngModel]="rowData?.discountedLinePrice"
                                        (ngModelChange)="rowData.discountedLinePrice = $event"
                                        [attr.data-testid]="'line-price-input-' + rowIndex"
                                    ></app-dli-line-sum-input>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span
                                        [ngClass]="{
                                            'font-bold':
                                                rowData?.type !== DocumentLineItemType.SBOMI,
                                            'italic': rowData?.type === DocumentLineItemType.SBOMI
                                        }"
                                        [attr.data-testid]="'line-price-display-' + rowIndex"
                                    >
                                        <!-- <i
                                            *ngIf="rowData?.type === DocumentLineItemType.SBOMH"
                                            class="fa-solid fa-sm clickable"
                                            [ngClass]="{
                                                'fa-link': rowData?.isCalculatedItemPrice,
                                                'fa-link-slash': !rowData?.isCalculatedItemPrice
                                            }"
                                            (click)="changeSBOMHStatus(rowData)"
                                        ></i> -->
                                        {{
                                            (rowData?.type === DocumentLineItemType.SBOMI
                                                ? '('
                                                : '') +
                                                (rowData?.discountedLinePrice | localeCurrency: '' :document()?.decimalPlaces) +
                                                (rowData?.type === DocumentLineItemType.SBOMI
                                                    ? ')'
                                                    : '')
                                        }}
                                    </span>
                                </ng-template>
                            }
                        </p-cellEditor>
                    </div>
                }
            </td>
            @if (
                this.document()?.status !== DocumentStatusType.CO &&
                this.document()?.status !== DocumentStatusType.RE
            ) {
                <td
                    pFrozenColumn
                    alignFrozen="right"
                    [frozen]="itemsSig()?.length > 0"
                    [attr.data-testid]="'actions-cell-' + rowIndex"
                >
                    <div class="icon-buttons">
                        <i
                            *ngIf="rowData?.type === DocumentLineItemType.SBOMH"
                            class="fa-solid fa-sm"
                            [pTooltip]="
                                editModel?.()?.id === rowData.id || !rowData.id
                                    ? ('document-line-item.set-is-calculated-item-price'
                                      | translate)
                                    : ('document-line-item.set-is-calculated-item-price-disabled'
                                      | translate)
                            "
                            [ngClass]="{
                                'fa-link': rowData?.isCalculatedItemPrice,
                                'fa-link-slash': !rowData?.isCalculatedItemPrice,
                                'clickable': editModel?.()?.id === rowData.id || !rowData.id,
                                'text-slate-300 dark:text-slate-600': !(
                                    editModel?.()?.id === rowData.id || !rowData.id
                                ),
                                'hover:text-slate-300 dark:hover:text-slate-600': !(
                                    editModel?.()?.id === rowData.id || !rowData.id
                                ),
                                'text-slate-600 dark:text-slate-300':
                                    editModel?.()?.id === rowData.id || !rowData.id,
                                'hover:text-slate-600 dark:hover:text-slate-300':
                                    editModel?.()?.id === rowData.id || !rowData.id
                            }"
                            (click)="
                                editModel?.()?.id === rowData.id || !rowData.id
                                    ? changeSBOMHStatus(rowData)
                                    : ''
                            "
                            [attr.data-testid]="
                                'toggle-calculated-price-pos-' +
                                (rowData?.positionNumber || rowIndex)
                            "
                        ></i>
                        <!-- PLUS Add Button -->
                        <a
                            *ngIf="!editing"
                            [ngClass]="{
                                'text-slate-300': rowData?.disabled || IsLoading,
                                'hover:text-slate-300': rowData?.disabled || IsLoading,
                                'text-slate-600': !rowData?.disabled && !IsLoading,
                                'hover:text-slate-400': !rowData?.disabled && !IsLoading,
                                'clickable': !rowData?.disabled && !IsLoading
                            }"
                            class="fa-solid fa-plus ms-1"
                            tabindex="0"
                            (keyup.enter)="addNewItem(rowIndex, { disabled: rowData.disabled || IsLoading })"
                            (click)="addNewItem(rowIndex, { disabled: rowData.disabled || IsLoading })"
                            [attr.data-testid]="
                                'add-line-item-btn-pos-' + (rowData?.positionNumber || rowIndex)
                            "
                        ></a>
                        <!-- X Delete Button -->
                        <a
                            *ngIf="!editing"
                            [ngClass]="{
                                'text-slate-300 dark:text-slate-600':
                                    rowData?.disabled || isLineItemEditBlocked(rowData),
                                'hover:text-slate-300 dark:hover:text-slate-600':
                                    rowData?.disabled || isLineItemEditBlocked(rowData),
                                'text-red-600': !(rowData?.disabled || isLineItemEditBlocked(rowData)),
                                'hover:text-red-400': !(
                                    rowData?.disabled || isLineItemEditBlocked(rowData)
                                ),
                                'clickable': !(rowData?.disabled || isLineItemEditBlocked(rowData))
                            }"
                            class="fa-solid fa-times ms-2 me-1"
                            tabindex="0"
                            (keyup.enter)="
                                rowData?.disabled || isLineItemEditBlocked(rowData)
                                    ? null
                                    : deleteDLIs([rowData])
                            "
                            (click)="
                                rowData?.disabled || isLineItemEditBlocked(rowData)
                                    ? null
                                    : deleteDLIs([rowData])
                            "
                            [attr.data-testid]="
                                'delete-line-item-btn-pos-' + (rowData?.positionNumber || rowIndex)
                            "
                        ></a>
                        <!-- Check Edit Button -->
                        <a
                            *ngIf="editing"
                            [ngClass]="{
                                'text-slate-300': rowData?.disabled || !canSaveLineItem(rowData),
                                'hover:text-slate-300': rowData?.disabled || !canSaveLineItem(rowData),
                                'text-green-500': !rowData?.disabled && canSaveLineItem(rowData),
                                'hover:text-green-300': !rowData?.disabled && canSaveLineItem(rowData),
                                'clickable': !rowData?.disabled && canSaveLineItem(rowData)
                            }"
                            class="fa-solid fa-check ms-1"
                            tabindex="0"
                            [attr.aria-disabled]="canSaveLineItem(rowData) ? null : true"
                            (keyup.enter)="canSaveLineItem(rowData) ? onRowEditSave(rowData, rowIndex) : null"
                            (click)="canSaveLineItem(rowData) ? onRowEditSave(rowData, rowIndex) : null"
                            [attr.data-testid]="
                                'save-line-item-btn-pos-' + (rowData?.positionNumber || rowIndex)
                            "
                        ></a>
                        <!-- UNDO Edit Button -->
                        <a
                            *ngIf="editing"
                            [ngClass]="{
                                'text-slate-300': rowData?.disabled,
                                'hover:text-slate-300': rowData?.disabled,
                                'text-slate-600': !rowData?.disabled,
                                'hover:text-slate-400': !rowData?.disabled,
                                'clickable': !rowData?.disabled
                            }"
                            class="fa-solid fa-rotate-left ms-2 me-1"
                            tabindex="0"
                            (keyup.enter)="onRowEditCancel(editModel(), editRowIndex)"
                            (click)="onRowEditCancel(editModel(), editRowIndex)"
                            [attr.data-testid]="
                                'cancel-line-item-edit-btn-pos-' +
                                (rowData?.positionNumber || rowIndex)
                            "
                        ></a>
                    </div>
                </td>
            }
        </ng-template>
        <!-- Edit Detail Template -->
        <ng-template
            #additionalDetailRow
            let-rowData="rowData"
            let-rowIndex="rowIndex"
            let-columns="columns"
            let-table="table"
        >
            <tr
                *ngIf="expandedRowKeys.includes(rowData?.id)"
                class="dark:bg-gray-800"
                [attr.data-testid]="'detail-row-pos-' + (rowData?.positionNumber || 'unknown')"
            >
                <td [colSpan]="columns.length + 3">
                    <div
                        class="detail-fields-wrapper p-4 rounded-md bg-white text-black dark:bg-gray-900 dark:text-white"
                        [style.width.px]="this.tableWidth"
                        [attr.data-testid]="
                            'detail-fields-wrapper-pos-' + (rowData?.positionNumber || 'unknown')
                        "
                    >
                        <div class="detail-fields-overlay-grid">
                            <app-widget-add-edit-line-item-list-detail [dli]="rowData" [document]="this.document()"
                                [decimalPlaces]="document()?.decimalPlaces"
                                [direction]="this.document()?.documentDefinition?.documentDirection"
                                [stockAction]="this.document()?.documentDefinition?.stockAction"
                                [(activeProductPriceInfos)]="this.activeProductPriceInfos"
                                [(activeUnitConversionValue)]="this.activeUnitConversionValue"
                                [(activeUnitConversions)]="this.activeUnitConversions" [attr.data-testid]="
                                    'line-item-detail-pos-' + (rowData?.positionNumber || 'unknown')
                                " />
                            @if (!inEditingSig() && !isLineItemEditBlocked(rowData)) {
                            <div class="detail-fields-edit-overlay">
                                <i class="fa-solid fa-pencil clickable text-[12rem] text-gray-500/30 transition-colors duration-500 ease-in-out hover:text-gray-500/70"
                                    [pTooltip]="
                                            'document-line-item.start-edit-tooltip' | translate
                                        " (click)="onRowEditInit(rowData, rowIndex)"></i>
                            </div>
                            }
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template
            #groupheaderTemplate
            let-rowData
            let-columns="columns"
            let-editing="editing"
            let-frozen="frozen"
            let-expanded="expanded"
        >
            @if (!loadingSig()) {
                <tr
                    pRowGroupHeader
                    [attr.data-testid]="
                        'group-header-' + (rowData?.predecessorKey || 'no-predecessor')
                    "
                >
                    <td [attr.colspan]="columns.length + 3 + (checkboxMode ? 1 : 0)">
                        <div class="flex items-center gap-2 m-2">
                            <p-button
                                [pRowToggler]="rowData"
                                text
                                rounded
                                plain
                                class="mr-2 ml-1"
                                [icon]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"
                                [attr.data-testid]="
                                    'group-toggle-btn-' +
                                    (rowData?.predecessorKey || 'no-predecessor')
                                "
                            ></p-button>
                            @if (!rowData?.getDocumentLineItemPredecessorRelationLinks?.length) {
                                <span [attr.data-testid]="'no-predecessor-label'">{{
                                    'document-line-item.no-predecessor' | translate
                                }}</span>
                            } @else {
                                <div [attr.data-testid]="'predecessor-links'">
                                    @for (
                                        link of getDistinctLinks(rowData);
                                        track $index
                                    ) {
                                        @if ($index > 0) {
                                            <span>, </span>
                                        }
                                        @let docDefName = ('documents.' + link.sourceDocumentDefinitionIdentifier) | translate;
                                        @if (docDefName == 'documents.' + link.sourceDocumentDefinitionIdentifier && link.sourceDocumentDefinitionDescription) {
                                            {{
                                               link.sourceDocumentDefinitionDescription
                                            }}
                                        }
                                        @else {
                                            {{
                                                'documents.' + link.sourceDocumentDefinitionIdentifier
                                                    | translate
                                            }}
                                        }
                                        <a
                                            [routerLink]="
                                                '/documents/edit/' + link.sourceDocumentId
                                            "
                                            [attr.data-testid]="
                                                'predecessor-link-' + link.sourceDocumentIdentifier
                                            "
                                        >
                                            <span>{{ link.sourceDocumentIdentifier }}</span>
                                        </a>
                                        <span class="opacity-80 italic ml-1"
                                            >({{
                                                link.sourceDocumentDate | localeDate: 'shortDate'
                                            }})</span
                                        >
                                    }
                                </div>
                            }
                        </div>
                    </td>
                </tr>
            }
        </ng-template>
    </app-base-list-wrapper>
</div>

<p-drawer
        [visible]="productStorageVisible()"
        (visibleChange)="productStorageVisible.set($event)"
        appendTo="body"
        position="right"
        styleClass="!w-full md:!w-80 lg:!w-[40rem]"
        [attr.data-testid]="'line-item-warehouse-stock-drawer'"
    >
        @if (productStorageVisible() && warehouseSidebarProductId()) {
            <app-product-stock-chart-diagram
                [productId]="warehouseSidebarProductId()!"
                [stackLayout]="true"
            ></app-product-stock-chart-diagram>
        }
    </p-drawer>

    <p-drawer
        [visible]="stockHistoryDrawerOpen()"
        (visibleChange)="stockHistoryDrawerOpen.set($event)"
        position="right"
        styleClass="line-item-stock-history-drawer !w-full md:!w-96 lg:!w-[28rem] xl:!w-[32rem]"
        [attr.data-testid]="'line-item-stock-history-drawer'"
    >
        <ng-template #header>
            <div class="flex min-w-0 flex-1 items-center gap-2 pe-2">
                <span class="min-w-0 flex-1 truncate font-semibold text-slate-900 dark:text-slate-100">
                    {{ 'document-line-item.stock-history.transaction-details' | translate }}
                </span>
                @if (stockHistoryShowTransactionCount()) {
                    <span
                        class="inline-flex shrink-0"
                        [pTooltip]="
                            'document-line-item.stock-history.transaction-count'
                                | translate: { count: stockHistoryTransactionCount() }
                        "
                        tooltipPosition="bottom"
                        tooltipStyleClass="stock-history-sort-tooltip"
                    >
                        <span
                            class="inline-flex items-center gap-1.5 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 shadow-sm dark:border-primary/35 dark:bg-primary/15"
                            role="status"
                            [attr.data-testid]="'stock-history-transaction-count'"
                            [attr.aria-label]="
                                'document-line-item.stock-history.transaction-count'
                                    | translate: { count: stockHistoryTransactionCount() }
                            "
                        >
                            <i
                                class="fa-solid fa-layer-group text-[10px] text-primary/80 dark:text-primary/90"
                                aria-hidden="true"
                            ></i>
                            <span
                                class="text-xs font-semibold leading-none tabular-nums text-primary"
                            >
                                {{ stockHistoryTransactionCount() }}
                            </span>
                        </span>
                    </span>
                }
                <span
                    class="inline-flex shrink-0"
                    [pTooltip]="stockHistoryValueToggleTooltipKey() | translate"
                    tooltipPosition="bottom"
                    tooltipStyleClass="stock-history-sort-tooltip"
                >
                    <p-button
                        type="button"
                        [text]="true"
                        [rounded]="true"
                        [icon]="
                            stockHistoryShowValue()
                                ? 'fa-solid fa-eye-slash'
                                : 'fa-solid fa-eye'
                        "
                        [ngClass]="{ 'text-primary': stockHistoryShowValue() }"
                        [attr.aria-pressed]="stockHistoryShowValue()"
                        [attr.aria-label]="stockHistoryValueToggleTooltipKey() | translate"
                        (onClick)="toggleStockHistoryValue()"
                        [attr.data-testid]="'stock-history-toggle-value'"
                    />
                </span>
                @if (stockHistoryShowSort()) {
                    <span
                        class="inline-flex shrink-0"
                        [pTooltip]="stockHistorySortTooltip() | translate"
                        tooltipPosition="bottom"
                        tooltipStyleClass="stock-history-sort-tooltip"
                    >
                        <p-button
                            type="button"
                            [text]="true"
                            [rounded]="true"
                            [icon]="stockHistorySortIcon()"
                            [attr.aria-label]="stockHistorySortTooltip() | translate"
                            (onClick)="toggleStockHistorySort()"
                            [attr.data-testid]="'stock-history-sort-by-date'"
                        />
                    </span>
                }
            </div>
        </ng-template>
        @if (stockHistoryDrawerOpen()) {
            <div class="line-item-stock-history-drawer-body box-border flex min-h-0 w-full min-w-0 flex-1 flex-col px-3 pb-3">
                <app-stock-history-cards
                    [dliId]="stockHistoryDliId()"
                    [stockAction]="document()?.documentDefinition?.stockAction"
                    [currencyCode]="document()?.currency"
                    [showTransactionValue]="stockHistoryShowValue()"
                    [defaultUnitIdentifier]="stockHistoryLineItemUnitIdentifier()"
                />
            </div>
        }
        <ng-template pTemplate="footer">
            @if (showStockHistoryFooter()) {
                <div class="border-t border-slate-200 px-3 pb-3 pt-3 dark:border-slate-600">
                    @if (stockHistoryNavigating()) {
                        <div
                            class="mb-2 flex items-center justify-center gap-2 text-sm text-slate-500 dark:text-slate-400"
                            [attr.data-testid]="'stock-history-navigating'"
                        >
                            <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                            <span>{{ 'common.loading' | translate }}</span>
                        </div>
                    }
                    <div class="grid grid-cols-2 gap-2">
                    <p-button
                        type="button"
                        styleClass="w-full"
                        icon="fa-solid fa-chevron-left"
                        [label]="'document-line-item.stock-history.previous-dli' | translate"
                        [disabled]="!hasPreviousStockHistoryDli() || stockHistoryNavigating() || inEditingSig()"
                        (onClick)="goToAdjacentStockHistoryDli(-1)"
                        [attr.data-testid]="'stock-history-previous-dli'"
                    />
                    <p-button
                        type="button"
                        styleClass="w-full"
                        icon="fa-solid fa-chevron-right"
                        iconPos="right"
                        [label]="'document-line-item.stock-history.next-dli' | translate"
                        [disabled]="!hasNextStockHistoryDli() || stockHistoryNavigating() || inEditingSig()"
                        (onClick)="goToAdjacentStockHistoryDli(1)"
                        [attr.data-testid]="'stock-history-next-dli'"
                    />
                    </div>
                </div>
            }
        </ng-template>
    </p-drawer>

    <p-drawer
        [visible]="priceHistoryDrawerOpen()"
        (visibleChange)="priceHistoryDrawerOpen.set($event)"
        appendTo="body"
        position="right"
        styleClass="!w-full md:!w-96 lg:!w-[40rem] xl:!w-[48rem]"
        [attr.data-testid]="'line-item-price-history-drawer'"
    >
        <ng-template #header>
            <span class="min-w-0 flex-1 truncate font-semibold text-slate-900 dark:text-slate-100">
                {{ 'document-line-item.price-history.title' | translate }}
            </span>
        </ng-template>
        @if (priceHistoryDrawerOpen() && priceHistoryProductId()) {
            <app-widget-line-item-price-history
                [productId]="priceHistoryProductId()!"
                [customerId]="priceHistoryCustomerId()"
                [documentDirection]="priceHistoryDocumentDirection()"
                [documentType]="priceHistoryDocumentType()"
                [applyPriceEnabled]="canApplyPriceFromHistory()"
                (unitPriceApply)="onPriceHistoryUnitPriceApply($event)"
            />
        }
    </p-drawer>

    <ng-template #quantityColumnHeader let-col="col" let-headerLabel="headerLabel">
        <div class="flex w-full flex-row items-center justify-end gap-2">
            <span [pTooltip]="col?.tooltip">{{ headerLabel }}</span>
            @if (documentItemsQuantitySumDisplay() != null) {
                <span
                    class="inline-flex items-center gap-1.5 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary shadow-sm dark:border-primary/35 dark:bg-primary/15"
                    [attr.data-testid]="'header-quantity-sum-pill'"
                >
                    {{ documentItemsQuantitySumDisplay() }}
                </span>
            }
        </div>
    </ng-template>

    <ng-template #openQuantityColumnHeader let-col="col" let-headerLabel="headerLabel">
        <div class="flex w-full flex-row items-center justify-end gap-2">
            <span [pTooltip]="col?.tooltip">{{ headerLabel }}</span>
            @if (documentItemsOpenQuantitySumDisplay() != null) {
                <span
                    class="inline-flex items-center gap-1.5 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary shadow-sm dark:border-primary/35 dark:bg-primary/15"
                    [attr.data-testid]="'header-open-quantity-sum-pill'"
                >
                    {{ documentItemsOpenQuantitySumDisplay() }}
                </span>
            }
        </div>
    </ng-template>

    <ng-template #requestedQuantityColumnHeader let-col="col" let-headerLabel="headerLabel">
        <div class="flex w-full flex-row items-center justify-end gap-2">
            <span [pTooltip]="col?.tooltip">{{ headerLabel }}</span>
            @if (documentItemsRequestedQuantitySumDisplay() != null) {
                <span
                    class="inline-flex items-center gap-1.5 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary shadow-sm dark:border-primary/35 dark:bg-primary/15"
                    [attr.data-testid]="'header-requested-quantity-sum-pill'"
                >
                    {{ documentItemsRequestedQuantitySumDisplay() }}
                </span>
            }
        </div>
    </ng-template>

    <ng-template #transferredQuantityColumnHeader let-col="col" let-headerLabel="headerLabel">
        <div class="flex w-full flex-row items-center justify-end gap-2">
            <span [pTooltip]="col?.tooltip">{{ headerLabel }}</span>
            @if (documentItemsTransferredQuantitySumDisplay() != null) {
                <span
                    class="inline-flex items-center gap-1.5 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary shadow-sm dark:border-primary/35 dark:bg-primary/15"
                    [attr.data-testid]="'header-transferred-quantity-sum-pill'"
                >
                    {{ documentItemsTransferredQuantitySumDisplay() }}
                </span>
            }
        </div>
    </ng-template>
